import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { WrapperData, BreadCrumb } from 'modules/theme';
import { AreaInner, ChartWrapper, DataWrapperClass, FlexRow, HeadingSpan, InboundCall, InsightContent, InsightRow, InsightTitle, OutboundCall } from '../styles/main';
import { BarItems, Button } from 'modules/theme';
import { Bar, Line, Pie } from 'react-chartjs-2';
import AdminDashboardTileTheme from './AdminDashboardTileTheme';
import { FiMessageSquare } from 'react-icons/fi';
import { Col, Row } from 'react-bootstrap';
import APIManager from 'modules/common/apiManager';
import moment from 'moment-timezone';
// import Filter from './filter/Filter';
import { InsightWrapper } from '../../../../screens/reporting/styles';
import Filter from './Filter';
import { withRouter } from 'react-router';
import { BiMessageCheck, BiMessageDots, BiMessageError, BiMessageX } from 'react-icons/bi';
import { MdMarkChatRead, MdSendToMobile } from 'react-icons/md';
import HRNumbers from 'human-readable-numbers';



const deliveredIconStyle = {

    color: "#93C572",
    width: "50px",
    height: "auto",
    backgroundColor: "#ECFFDC",
    textAlign: "center",
    borderRadius: "15px",
    paddingTop: "14px",
    float: "left",
    marginRight: "11px",
    marginTop: "8px",
    padding: "10px"
}
const failedIconStyle = {

    color: "#ff4500",
    width: "50px",
    height: "auto",
    backgroundColor: "#FBCEB1",
    textAlign: "center",
    borderRadius: "15px",
    paddingTop: "14px",
    float: "left",
    marginRight: "11px",
    marginTop: "8px",
    padding: "10px"
}
const unDeliveredIconStyle = {

    color: "#7F00FF",
    width: "50px",
    height: "auto",
    backgroundColor: "#E6E6FA",
    textAlign: "center",
    borderRadius: "15px",
    // paddingTop: "14px",
    float: "left",
    marginRight: "11px",
    marginTop: "8px",
    padding: "10px"
}
const pendingIconStyle = {

  color: "#F28C28",
    width: "50px",
    height: "auto",
    backgroundColor: "#FFE5B4",
    textAlign: "center",
    borderRadius: "15px",
    paddingTop: "14px",
    float: "left",
    marginRight: "11px",
    marginTop: "8px",
    padding: "10px"
}


export class AdminDashboardTheme extends Component {
  

  constructor(props) {
    super(props);
    this.mAPI = new APIManager();
    let zone = {};
    var timeZone = moment.tz.guess();
    zone.value = timeZone;
    zone.label = zone.value;
    if (window.localStorage && window.localStorage.getItem('timezone')) {
      zone = JSON.parse(window.localStorage.getItem('timezone'));
    }
    if (zone === null) {
      timeZone = moment.tz.guess();
      zone = {};
      zone.value = timeZone;
      zone.label = zone.value;
    }
    this.currentTimestamp =
      parseInt(
        moment()
          .tz(zone.value)
          .format('X')
      ) * 1000;
    this.currentStartTimestamp =
      parseInt(
        moment()
          .startOf('day')
          .tz(zone.value)
          .format('X')
      ) * 1000;

    this.currentEndTimestamp =
    parseInt(
      moment()
        .endOf('day')
        .tz(zone.value)
        .format('X')
    ) * 1000;

    this.moduleName = 'Dashboard'
    this.getData = this.getData.bind(this);
    this.getSelectedColumnNames = this.getSelectedColumnNames.bind(this);
    this.generateGraph = this.generateGraph.bind(this);

    this.state = {
      startDate: this.currentStartTimestamp,
      endDate: this.currentEndTimestamp,
      totalPerPage: 0,
      perPageCount: 10,
      currentPage: 1,
      loading: true,
      isActive: false,

      filters: [],
      total_submission_rcs: 0,
      failed_rcs: 0,
      // expired_sms: 0,

      // smsTableData: [
      //   {
      //     index: 1,
      //     title: "Pending",
      //     count: 0
      //   },
      //   {
      //     index: 2,
      //     title: "Delivered",
      //     count: 0
      //   },
      //   {
      //     index: 3,
      //     title: "Expired",
      //     count: 0
      //   },
      //   {
      //     index: 4,
      //     title: "Undelivered",
      //     count: 0
      //   }
      // ],

      dashboardTile: [
        {title: "Delivered", count: 0, isSecs: false, icon: <BiMessageCheck style={deliveredIconStyle} />},
            {title: "Undelivered", count: 0, isSecs: false, icon: <BiMessageDots style={unDeliveredIconStyle} />},
            {title: "Pending", count: 0, isSecs: false, icon: <BiMessageError style={pendingIconStyle} />},
            {title: "Rejected", count: 0, isSecs: false, icon: <BiMessageX style={failedIconStyle} />},
            
      ],
      dashboardSentGraph: this.generateGraph({
        labels: ["Delivered","Undelivered", "Pending", "Expired", "Rejected"],
        data : [
          {
            label: 'RCS Analysis',
            data: [0,0,0,0,0,0],
            backgroundColor: [
              '#2B70A7',
              '#BF1E2E',
              '#EF4136',
              '#F15A2B',
              '#E2B37D'
          ],
          },
           
        ]
      }),
      failed_rcs: 0,
      dashboardHourlySummary: {},
      dashboardSummary: [],
      dashboardWeeklyReport: {},
      dashboardMonthlySummary: this.generateGraph({
        labels: ["Januaray","February", "March", "April", "May", "June"],
        data : [
          {
            label: 'Delivered',
            data: [0,0,0,0,0,0],
            // backgroundColor: '#2b78a2'
          },
          {
            label: 'Undelivered',
            data: [0,0,0,0,0,0],
            // backgroundColor: '#6ea8c9'
          },{
            label: 'Rejected',
            data: [0,0,0,0,0,0],
            backgroundColor: '#b6dee7'
          
          },{
            label: 'Pending',
            data: [0,0,0,0,0,0],
            backgroundColor: '#f2cdaf'
          },
          {
            label: 'Expired',
            data: [0,0,0,0,0,0],
            backgroundColor: '#f9e2cf'
          },
        ]
      }),
      
    }
    this.handleFireAPI = this.handleFireAPI.bind(this);
    this.handleMonthWeekHourlyAPI = this.handleMonthWeekHourlyAPI.bind(this);
    this.handleFireAPI();
    this.handleMonthWeekHourlyAPI();
  }

  componentDidMount() {
  }
  

  open() {
    if (this.state.isActive) {
      this.setState({ isActive: false });
    } else {
      this.setState({ isActive: true });
    }
  }

  addGraphColor(data, colors) {
    return data.map((element, index) => {
      element.borderColor = colors && colors[index] ? colors[index] : "#22aa99";
      element.borderColor = colors && colors[index] ? colors[index] : "#22aa99";
      return element
    })
  }
  addBarGraphColor(data, colors) {
    return data.map((element, index) => {
      element.backgroundColor = colors && colors[index] ? colors[index] : "#22aa99";
      return element
    })
  }

  getData(data) {
    console.log("dashboard data",data);
    let filter = {
      // "date": data.startDate || "",
      // "sendEndTime": data.endDate || "",
      // "timezone": data.timezone || {},
      // "sender": data.selectedSenderList ? data.selectedSenderList.value : "",
      "from_date": data.startDate || "",
      "to_date": data.endDate || "",
      // "to": data.toSelector || "",
      // "freeTextSearch": data.freeTextSearch || "",
    }
    console.log("filter data",filter);
    this.setState({ "Filters": filter })
    // this.getList(1, this.state.perPageCount, filter)
    // this.downloadReport(1, this.state.perPageCount, filter)
    this.handleFireAPI(filter);
  }

  handleMonthWeekHourlyAPI() {
    
    this.mAPI.sendPostAPI(
      `/analytics/`,
      {},
      data => {
        this.setState({ loading: false });
        if(data) {
          console.log(data);

          // let allMonths = ["1","2","3","4","5","6","7","8","9","10","11","12"];
          let currentMonth = new Date().getMonth()+1;
          let month = data.month;
          let weekly = data.weekly;
          let hour = data.hour;

          let gLabels = [];
          let gData = [];

          let hourlyGraph = this.generateGraph({
            labels: ["Sent","Delivered","Undelivered","Total"],
            data: [
              {
                label: "Hourly Message",
                data: [hour.SENT || 0, hour.DELIVERED || 0 , hour.UNDELIVERED || 0, hour.TOTAL || 0],
                backgroundColor: "#99bddf",
                borderColor: "#2f4f75"
              },
               
            ]
          });
          
          gLabels = weekly.length > 0 ? Object.keys(weekly[0]) : [];
          
          gData = [
            {
              label: 'Delivered',
              data: gLabels.map(date => weekly[0][date] ? weekly[0][date].DELIVERED : 0),
              borderColor: 'rgb(50, 162, 25)',
              // borderColor: 'rgb(255, 79, 112)',
              fill: false,
              // backgroundColor: 'rgba(255, 99, 132, 0.5)',
            },
            {
              label: 'Sent',
              data: gLabels.map(date => weekly[0][date] ? weekly[0][date].SENT : 0),
              borderColor: 'rgb(43, 122, 135)',
              fill: false,
              // backgroundColor: 'rgba(53, 162, 235, 0.5)',
            },
            // {
            //   label: 'Read',
            //   data: gLabels.map(date => weekly[0][date] ? weekly[0][date].READ : 0),
            //   borderColor: 'rgb(55, 199, 122)',
            //   fill: false,
            //   // backgroundColor: 'rgba(255, 99, 132, 0.5)',
            // },
            {
              label: 'Undelivered',
              data: gLabels.map(date => weekly[0][date] ? weekly[0][date].UNDELIVERED : 0),
              borderColor: 'rgb(255,0,0)',
              fill: false,
              // backgroundColor: 'rgba(53, 162, 235, 0.5)',
            }
            // ,{
            //   label: 'Total',
            //   data: gLabels.map(date => weekly[0][date] ? weekly[0][date].TOTAL : 0),
            //   borderColor: '#FF4500',
            //   fill: false,
            //   // backgroundColor: 'rgba(255, 99, 132, 0.5)',
            // }
            ];

          let dashboardWeeklyReport = {labels: gLabels, datasets: gData};

          gLabels = Object.keys(month[0]);

          gData = [
            {
              label: 'Sent',
              data: gLabels.map(date => month[0][date] ? month[0][date].SENT : 0),
              // borderColor: 'rgb(255,0,0)',
              fill: false,
              // backgroundColor:"rgb(43, 122, 135)",
              backgroundColor: '#FF4500',
            },
            {
              label: 'Delivered',
              data: gLabels.map(date => month[0][date] ? month[0][date].DELIVERED : 0),
              // borderColor: 'rgb(43, 122, 135)',
              fill: false,
              // backgroundColor: 'rgb(50, 162, 25)',
              backgroundColor: '#0096FF',
            },
            {
              label: 'Undelivered',
              data: gLabels.map(date => month[0][date] ? month[0][date].UNDELIVERED : 0),
              // borderColor: 'rgb(55, 199, 122)',
              fill: false,
              // backgroundColor: "rgb(43, 122, 135)",
              backgroundColor: '#A020F0',
            },
            // {
            //   label: 'Read',
            //   data: gLabels.map(date => month[0][date] ? month[0][date].READ : 0),
            //   // borderColor: 'rgb(50, 162, 25)',
            //   fill: false,
            //   backgroundColor: '#FF5733',
            // },
            
            // {
            //   label: 'Total',
            //   data: gLabels.map(date => month[0][date] ? month[0][date].TOTAL : 0),
            //   // borderColor: 'rgb(255, 79, 112)',
            //   fill: false,
            //   backgroundColor: '#FF4500',
            // }
            ];

          let dashboardMonthlySummary = {labels: gLabels, datasets: gData};

          // setting state
           this.setState({
            dashboardMonthlySummary: dashboardMonthlySummary,
            dashboardWeeklyReport: dashboardWeeklyReport,
            dashboardHourlySummary: hourlyGraph
           })
        }
        else{ 
          console.log("no data");
          
        }
      },
      (error, data) => {
        console.log(`Error:`, error);
        
      },
      "public"
    );
    
    
  
  }

  handleFireAPI(filter = '') {
    console.log(`Dashboard URL ->`);
    // var that = this;
    this.setState({ loading: true });

    filter = filter==="" || filter.date === "" || filter.selectedSenderList === "" ?  {from_date: this.state.startDate, to_date: this.state.endDate} : filter;

    console.log("filter data without filter => ", filter);

    this.mAPI.sendPostAPI(
      `/dashboard/`,
      filter,
      data => {
        this.setState({ loading: false });
        if(data) {
           console.log(data);
           let tileData = data.status;
           let dashboardTile = [
            {title: "Sent", count: HRNumbers.toHumanString(tileData.SENT || 0), isSecs: false, icon: <MdSendToMobile style={pendingIconStyle} />},
            {title: "Delivered", count: HRNumbers.toHumanString(tileData.DELIVERED || 0), isSecs: false, icon: <BiMessageCheck style={deliveredIconStyle} />},
            {title: "Read", count: HRNumbers.toHumanString(data.READ || 0), isSecs: false, icon: <MdMarkChatRead style={failedIconStyle} />},
            {title: "Undelivered", count: HRNumbers.toHumanString(tileData.UNDELIVERED || 0), isSecs: false, icon: <BiMessageError style={unDeliveredIconStyle} />},
            // {title: "Failed SMS", count: tileData.EXPIRED || 0, isSecs: false, icon: <BiMessageX style={{fontSize: "25px", color:"red"}} />},
            
          ]
          //  let dashboardTile = tileData.map(callStatus => (
          //   { title: callStatus.dlrStatus.charAt(0).toUpperCase()+ callStatus.dlrStatus.slice(1).toLowerCase(), count: callStatus.countDlrStatus, isSecs: false, icon: <FiMessageSquare style={{fontSize: "25px"}} /> }
          //  ))
           let gLabels = Object.keys(tileData) || [];
           let gData = gLabels.map(callData => tileData[callData]) || [];
           let dashboardSentGraph = this.generateGraph({
            labels: gLabels,
            data: [
              {
                data: gData,
             backgroundColor: [
              // "#c1e7ff", "#9dc6e0", "#7aa6c2", "#5886a5", "#346888"
              'rgb(26, 35, 126)',
            'rgb(48, 63, 159)',
            'rgb(63, 81, 181)',
            'rgb(121, 134, 203)',
            'rgb(197, 202, 233)',
            'rgb(232, 234, 246)'
            ],
               
             
            // backgroundColor: [
            //   "#daf1de", "#d6e9aa", "#aee6cb", "#85d4be", "#96dfd8"
            // ],
            //   backgroundColor: [
            //     "#287f8e", "#c0b65a", "#a6d2d4", "#e06547", "#b2b7bf"
            // ]
            //   backgroundColor: [
            //     "#fd5901", "#f78104", "#faab36", "#249ea0", "#008083"
            // ],
            //   backgroundColor: [
            //     '#2085ec',
            //     '#58508D',
            //     '#BC5090',
            //     '#FF6361',
            //     '#FFA600'
            // ],
            //   backgroundColor: [
            //     '#cea9bc',
            //     '#2085ec',
            //     '#28AAE1',
            //     '#8464a0',
            //     '#F15A2B'
            // ],
              borderWidth: 0
              },
            ]
          });
          let dashboardSummary = this.generateGraph({
            labels: gLabels,
            data: [
              {
                label: "RCS Analysis",
                data: gData,
                backgroundColor: [
                  // '#d5e9f4',
                  // "#2f4f75",
                  // '#99bddf',
                  // '#9a9cc2',
                  // '#feb78d',
                  "#745CB8", "#2196F3", "#D4455", "#FFAB91", "#D84315",
                  // '#fdcfbb',
                  // '#ff97A5',
                  // '#fcd353',
                  // '#feb78d',
                  // '#fd8b64'
              ]
              },
               
            ]
          })
          // setting state
           this.setState({
            showNoDataAvailable: gData.every(count => count===0),

            dashboardTile: dashboardTile,

            failed_rcs:data.failed_rcs || 0,
            total_submission_rcs:data.total_submission || 0,

            dashboardSentGraph: dashboardSentGraph,
            dashboardSummary: dashboardSummary
           })
        }
        else{ 
          console.log("no data");
          this.setState({
            // smsTableData: [
            //   {
            //     index: 1,
            //     title: "Pending",
            //     count: 0
            //   },
            //   {
            //     index: 2,
            //     title: "Delivered",
            //     count: 0
            //   },
            //   {
            //     index: 3,
            //     title: "Expired",
            //     count: 0
            //   },
            //   {
            //     index: 4,
            //     title: "Undelivered",
            //     count: 0
            //   }
            // ],
            dashboardTile: [
              {title: "Submission", count: 0, isSecs: false, icon: <FiMessageSquare style={{fontSize: "25px"}} />},
              {title: "Delivered", count: 0, isSecs: false, icon: <BiMessageCheck style={{fontSize: "25px"}} />},
              {title: "Pending", count: 0, isSecs: false, icon: <BiMessageError style={{fontSize: "25px"}} />},
              {title: "Failed", count: 0, isSecs: false, icon: <BiMessageX style={{fontSize: "25px"}} />}
            ],
            dashboardSentGraph: this.generateGraph({
              labels: ["Delivered","Undelivered", "Pending", "Expired", "Rejected"],
              data : [
                {
                  label: 'RCS Analysis',
                  data: [0,0,0,0,0,0],
                  backgroundColor: [
                    '#72b4eb',
                    '#2085ec',
                    '#28AAE1',
                    '#7aa6c2',
                    '#F15A2B'
                ]
                },
                 
              ]
            }),
            dashboardSummary: this.generateGraph({
              labels: ["Delivered","Undelivered", "Pending", "Expired", "Rejected"],
              datasets: [
                {
                  label: 'RCS Analysis',
                  data: [0,0,0,0,0,0],
                  backgroundColor: [
                    '#72b4eb',
                    '#2085ec',
                    '#28AAE1',
                    '#7aa6c2',
                    '#F15A2B'
                ]
                },
                 
              ]
            })
          })
          
        }
        // if (data && data.data) {
        //   // that.setState({ listData: data.data, total: data.count || 0 });
        // }
      },
      (error, data) => {
        console.log(`Error:`, error);
        // if (data) {
        //   Alert.error(` ${data.message}`);
        // } else {
        //   Alert.error(`${error}`);
        // }
      },
      "public"
    );
    
  }

  getSelectedColumnNames() {
    return [];
  }

  getReportName() {
    return 'default';
  }

  renderCharts() {
    return null;
  }

  renderContent() {
    const { history } = this.props;
    return (
      <InsightWrapper>
        {/* <span> */}
        <Filter
          filterList={[]}
          getSelectedColumnNames={this.getSelectedColumnNames}
          getData={this.getData}
          history={history}
          brands={[]}
          queryParams={{}}
          selectedFilter={this.state.selectedFilter}
          setFilter={this.setFilter}
          updateFilter={this.updateFilter}
        />
        {this.renderCharts()}
        {/* </span> */}
      </InsightWrapper>

    );
  }


  generateGraph(cData) {
    let tData = {
      labels: cData.labels,
      plot: {
        animation: {
          sequence: 3,
          effect: 4,
          method: 1,
          speed: 500
        }
      },
      datasets: []
    };
    if (cData.data) {
      cData.data.forEach(element => {
        let datasets = {
          label: element.label || "none",
          // lineTension: element.lineTension || 0.1,
          backgroundColor: element.backgroundColor || [
            'rgb(26, 35, 126)',
            'rgb(48, 63, 159)',
            'rgb(63, 81, 181)',
            'rgb(121, 134, 203)',
            'rgb(197, 202, 233)',
            'rgb(232, 234, 246)'
          ],
          // borderColor: element.borderColor || [
          //   'rgb(26, 35, 126)',
          //   'rgb(48, 63, 159)',
          //   'rgb(63, 81, 181)',
          //   'rgb(121, 134, 203)',
          //   'rgb(197, 202, 233)',
          //   'rgb(232, 234, 246)'
          // ],
          borderCapStyle: element.borderCapStyle || 'butt',
          borderDash: element.borderDash || [],
          borderDashOffset: element.borderDashOffset || 0.0,
          borderJoinStyle: element.borderJoinStyle || 'miter',
          pointBorderColor: element.pointBorderColor || '#4D528E',
          pointBackgroundColor: element.pointBackgroundColor || '#fff',
          pointBorderWidth: element.pointBorderWidth || 1,
          pointHoverRadius: element.pointHoverRadius || 5,
          pointHoverBackgroundColor: element.pointHoverBackgroundColor || '#4D528E',
          pointHoverBorderColor: element.pointHoverBorderColor || '#4D528E',
          pointHoverBorderWidth: element.pointHoverBorderWidth || 2,
          pointRadius: element.pointRadius || 1,
          pointHitRadius: element.pointHitRadius || 10,
          data: element.data || [],
          // fill: false
        }
        tData.datasets.push(datasets);
      });
    }
    return tData;
  }

  renderTitle(title) {
    const { __ } = this.context;
    return (
      <InsightTitle style={{ paddingTop: '20px', paddingLeft: '20px', margin: '0px', fontWeight: '500', textTransform: 'none' }}>
        {__(title)}
      </InsightTitle>
    );
  }

  // renderTable() {
  //   const { __ } = this.context;
  //   return (
  //     <Table whiteSpace="nowrap" bordered hover>
  //       <thead>
  //         <tr>
  //           <th>{__('Index')}</th>
  //           <th>{__('Title')}</th>
  //           <th>{__('Count')}</th>
  //         </tr>
  //       </thead>
  //       <tbody id="Despose">
  //         {this.state.smsTableData.map(data => (
  //           <tr key={data.index}>
  //             <td>{data.index}</td>
  //             <td>{data.title}</td>
  //             <td>{data.count}</td>
  //           </tr>
  //         ))}
  //       </tbody>
  //     </Table>
  //   );

  // }

  render() {

    const { __ } = this.context;
    const breadcrumb = [{ title: __('Dashboard'), link: '/dashboard' }];

    const content = (
      <div>
        <InsightContent>
          <FlexRow>
            
          </FlexRow>
        </InsightContent>
      </div>
    );

    const actionBarRight = (
      <BarItems>
        <Button
        className="step_1"
          btnStyle="filter"
          size="medium"
          onClick={() => this.open()}
        >
          <img src="/images/filter.png"  style={{ width: '15px', marginRight: '5px' }} />Filters
        </Button>
      </BarItems>
    );

    const pieOptions = {
      // maintainAspectRatio : false,
      // elements: {
      //   arc: {
      //     borderWidth: 1
      //   }
      // },
      legend: {
        position: 'bottom',
        labels: {
          boxWidth: 10
        }
      }
    };
    const lineOptions = {
      scales: {
        xAxes: [{
            ticks: {
              beginAtZero: true,
            },
            gridLines: {
              display:false
          }
        },],
        yAxes: [{
            ticks: {
              beginAtZero: true,
              userCallback: function(label, index, labels) {
                // when the floored value is the same as the value we have a whole number
                if (Math.floor(label) === label) {
                    return label;
                }

            },
            },
            gridLines: {
              display:false
          }
        }],
      }
    }
    const options = {
      scales: {
        xAxes: [{
            stacked: true,
            ticks: {
              beginAtZero: true,
            },
            gridLines: {
              display:false
          }
        },],
        yAxes: [{
            stacked: true,
            ticks: {
              beginAtZero: true,
            },
            gridLines: {
              display:false
          }
        }],
      }
      // scales: {
      //   xAxes: [{
      //     ticks: {
      //       beginAtZero: true
      //     },
      //     gridLines: {
      //       display:false
      //     },
      //   }],
      //   yAxes:[{
      //     gridLines: {
      //       display:false
      //   },
      //     barThickness: 15,
      //     grid: {
      //       drawOnChartArea: false, // only want the grid lines for one axis to show up
      //     },
      //   }]
      // }
        // xAxes: [
        //   {
        //     stacked: true,
        //     gridLines: {
        //       display: false
        //     },
        //     // barPercentage: 0.5
        //   }
        // ],
        // yAxes: [
        //   {
        //     stacked: true,
        //     gridLines: {
        //       display: false
        //     },
        //     // barPercentage: 0.5
        //     grid: {
        //       drawOnChartArea: false, // only want the grid lines for one axis to show up
        //     },
        //   }
        // ]
      // }
    };

    const contentData = (

      <div>
        {console.log('this.state.listData', this.state.listData)}
        <InsightContent>
          <Row>
            <Col
              sm={8}
              key={Math.random()}
              style={{ marginBottom: '20px' }}
              className='step_2'
            >
              <InsightRow className="status">
                <AdminDashboardTileTheme
                  loading={false}
                  data={this.state.dashboardTile}
                  options={options}
                />
              </InsightRow>
            </Col>
            <Col
              sm={4}
              key={Math.random()}
              style={{ marginBottom: '20px' }}
            >
              <InsightRow style={{ background: '#fff', borderRadius: '20px' }}>
                <HeadingSpan>
                  {this.renderTitle('Total Message Count')}
                </HeadingSpan>
                <Row>
                  <InboundCall>
                    <AreaInner>
                      <h5>Failed</h5>
                      <span style={{ float: 'right', fontSize:"22px" }}>{ HRNumbers.toHumanString(this.state.failed_rcs || 0)}</span>
                    </AreaInner>
                  </InboundCall>
                  <OutboundCall>
                    <AreaInner>
                      <h5>Total Submission</h5>
                      <span style={{ float: 'right', fontSize:"22px" }}>{ HRNumbers.toHumanString(this.state.total_submission_rcs || 0)}</span>
                    </AreaInner>
                  </OutboundCall>
                </Row>
              </InsightRow>
            </Col>
          </Row>

          <InsightRow>
            <FlexRow>
              <ChartWrapper height={"400px"} style={{ marginRight: '20px' }} className='step_3'>
                {this.renderTitle('RCS Analysis')}
                {/* {!this.state.showNoDataAvailable ?  */}
                <Pie
                  ref="chart"
                  data={this.state.dashboardSentGraph}
                  options={pieOptions}
                /> 
                {/* : "No Data Availble"} */}
                
              </ChartWrapper>
              <ChartWrapper height={"400px"}>
                {this.renderTitle('Hourly RCS Report')}
                {/* {!this.state.showNoDataAvailable ?  */}
                <Line
                  ref="chart"
                  data={this.state.dashboardHourlySummary}
                  options={lineOptions}
                />
                 {/* : "No Data Available"} */}
              </ChartWrapper>
            </FlexRow>
          </InsightRow>

          <InsightRow style={{ marginTop: '20px', marginBottom: '20px' }}>
            <FlexRow>
              <ChartWrapper height={"400px"} style={{ marginRight: '20px'}}>
                {/* {this.renderTable()} */}
                {this.renderTitle('Weekly RCS Report')}
                {/* {!this.state.showNoDataAvailable ?  */}
                <Line
                  ref="chart"
                  data={this.state.dashboardWeeklyReport}
                  // options={options}
                  options={lineOptions}
                /> 
                {/* : "No Data Available"} */}
              </ChartWrapper>
              <ChartWrapper height={"400px"} >
                {this.renderTitle('Monthly RCS Summary')}
                <Bar
                  ref="chart"
                  data={this.state.dashboardMonthlySummary}
                  options={options}
                />
              </ChartWrapper>
            </FlexRow>
          </InsightRow>

        </InsightContent>
      </div >
    );

    return (
      
            <div>
            <DataWrapperClass>
    
              {this.state.isActive && <WrapperData content={this.renderContent()} overflow={"true"} />}
    
              <WrapperData
                // header={<Wrapper.Header breadcrumb={breadcrumb} />}
                actionBar={
                  <WrapperData.ActionBar
                    left={
                      // <div breadcrumb={breadcrumb} />
                      <BreadCrumb breadcrumbs={breadcrumb} />
                      // <div>
                      //   {/* <ControlLabel>{this.moduleName}</ControlLabel> */}
                      //   <Wrapper.Header breadcrumb={breadcrumb} />
                      // </div>
                    }
                    right={actionBarRight}
                  />
                }
                content={content}
                style={{ overflow: "hidden" }}
                transparent={true}
              />
    
              <WrapperData
                content={contentData}
                style={{ overflow: "hidden" }}
                transparent={true}
              />
            </DataWrapperClass>
          </div>
          )
  }
}

AdminDashboardTheme.contextTypes = {
  __: PropTypes.func
};

export default withRouter(AdminDashboardTheme);


// WEBPACK FOOTER //
// ./src/modules/theme/theme1/common/components/AdminDashboardTheme.js